<template>
  <v-container fluid>
    <v-layout>
      <v-container>
        <v-card>
          <v-card-text>

            <bar-chart :chart-data="datacollection" :options="chartOptions"></bar-chart>

          </v-card-text>

          <v-snackbar
            v-model="snackbar"
            :multi-line="true"
            :timeout="6000"
            :top="true"
            :vertical="true"
          >
            {{ text }}
            <v-btn
              color="pink"
              flat
              @click="snackbar = false"
            >
              Close
            </v-btn>
          </v-snackbar>

        </v-card>
      </v-container>
    </v-layout>
  </v-container>
</template>

<script>
  import axios from 'axios'
  import Config from '../utils/Config'
  import AmplifyStore from '../store/store'
  import BarChart from './BarChart'

  export default {
    components: {
      BarChart,
    },
    data () {
      return {
        snackbar: false,
        datacollection: null,
        chartOptions: {
          title: {
            display: true,
            text: 'Ubermertics Account Metrics',
          },
          legend: {
            position: 'top',
          },
          tooltips: {
            mode: 'index',
            intersect: false,
          },
          responsive: true,
          scales: {
            xAxes: [
              {
                stacked: true,
              }],
            yAxes: [
              {
                stacked: true,
              }],
          },
        },
      }
    },
    mounted () {
      const idToken = AmplifyStore.state.user.signInUserSession.idToken.jwtToken
      axios.defaults.headers.common['Authorization'] = `Bearer ${idToken}`
      this.$emit('TriggerLoading', true)
      axios
        .get(`${Config.API_URL}/ubermetrics-account-countings`)
        .then(response => {
          this.$emit('TriggerLoading', false)
          console.info(response.data)

          const countings = response.data.sort(function (a, b) {
            return a.account_id - b.account_id
          })

          let labels = []
          let activeData = []
          let inactiveData = []
          countings.forEach(function (accountData) {
            labels.push(accountData.account_id)
            activeData.push(accountData.active_searches)
            inactiveData.push(accountData.inactive_searches)
          })

          this.datacollection = {
            labels: labels,
            datasets: [
              {
                label: 'ACTIVE SEARCHES',
                backgroundColor: '#388E3C',
                data: activeData,
              }, {
                label: 'INACTIVE SEARCHES',
                backgroundColor: '#B71C1C',
                data: inactiveData,
              },
            ],
          }

        })
        .catch(error => {
          console.log(error)
          this.errored = true
        })
    },
  }
</script>
